import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onGetStarted }) => {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <h1>Build Forms, Your Way</h1>
        <p>
          Say goodbye to complex form creation. Design, customize, and export forms
          effortlessly with our modern and intuitive platform.
        </p>
        <p>
          Start creating forms that work seamlessly on any website
          <br />
          no coding experience needed!
        </p>
        <button className="get-started-button" onClick={onGetStarted}>
          Get Started
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
